<template>
<div>


<div class="text-xs-center">
<v-dialog persistent v-model="groups.modals.checkGroup" width="950" scrollable>
<checker :modals='modals' :groups='groups'>  </checker>
</v-dialog>
</div>


<v-dialog  scrollable  width="450" persistent     v-model="modals.addGroups">
<add_groups :modals='modals'> </add_groups>
</v-dialog>


<delete_groups :modals='modals' :groups='groups'> </delete_groups>
<delete_selected :modals='modals' :groups='groups'> </delete_selected>

<v-dialog v-model="modals.history"  width="950" scrollable>
<history :modals='modals' :groups='groups'>    </history>
</v-dialog>

<v-dialog v-model="groups.modals.gr_params"  width="950" scrollable persistent>
<gr_params v-if="groups.modals.gr_params" :modals='modals' :groups='groups'>    </gr_params>
</v-dialog>

<v-dialog v-if="groups.modals.watch_new_followers" v-model="groups.modals.watch_new_followers"  width="950" scrollable persistent>
<watch_new_followers :modals='modals' :groups='groups'>    </watch_new_followers>
</v-dialog>

<v-dialog v-model="groups.modals.update_params"  width="950" scrollable persistent>
<update_params :modals='modals' :groups='groups'>    </update_params>
</v-dialog>


<v-container fluid >
<v-layout  d-flex>
<v-card>
<v-toolbar height="42" flat>

<v-toolbar-title style="color:#273C51;font-size:1.6em"> Новые подписки сообществ  </v-toolbar-title>
<v-spacer></v-spacer>

<v-tooltip top v-if="!groups.update_params.is">
<span>Включить автообновление</span>
<v-btn slot="activator" small icon @click="startAutoUpdater(1)">
<v-icon>mdi-flash</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top v-if="groups.update_params.is">
<span>Кликните, что бы выключить автообновление</span>
<v-btn color="#FF8F18" slot="activator" small icon @click="startAutoUpdater(0)">
<v-icon color="white">mdi-flash</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top  max-width="250">
<span>Общие для всех сообществ, настройки автообновления</span>
<v-btn slot="activator" small icon @click="groups.modals.update_params = true">
<v-icon>mdi-tune</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top  max-width="250">
<span>Кликните, что бы посмотреть новые подписки</span>
<v-btn   slot="activator" small icon @click="groups.modals.watch_new_followers = !groups.modals.watch_new_followers">
<v-icon >mdi-eye</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top>
<span>Добавить сообщество</span>
<v-btn slot="activator" small icon @click="modals.addGroups = !modals.addGroups">
<v-icon>mdi-plus</v-icon>
</v-btn>
</v-tooltip>

</v-toolbar>

<v-card-text>
<v-layout  >
<div style="border:solid #E3E4E8 1px;border-radius:3px;min-width:550px;max-width:550px">

<v-select
@change = "catData()"
v-model = "groups.selectedCat"
dense
solo
:items="groups.catList"
>
  <template  v-if="groups.selectedCat !== 'Общий список'" slot="append" >
  <v-icon @click.stop="groups.modals.renameCatSelected = true" color="#273C51">mdi-pencil</v-icon>
  <v-icon @click="groups.modals.removeCatSelected = true" color="red">mdi-close</v-icon>
  </template>
  <template slot="selection" >
  <span>  {{groups.selectedCat}} ({{groups.all.length}}) </span>
  </template>
  <template v-slot:item="{ item, attrs, on }">
  <v-list v-bind="attrs">
  <span v-if="item == groups.selectedCat" style="color:gray">  {{ item }} (текущий) </span>
  <span v-else>  {{ item }} </span>
  </v-list>
  </template>
</v-select>






    <v-dialog v-model="groups.modals.renameCatSelected" scrollable max-width="350px">
        <v-card>

          <v-toolbar flat >
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title style="color:gray">    {{groups.selectedCat}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon style="cursor: pointer" color="#4A76A8" @click.native="groups.modals.renameCatSelected = false" >mdi-close</v-icon>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-text fluid   style="height: 300px;">
         <v-text-field
         v-model="groups.renameList.title"
         label="Придумайте новое название"
         >
         </v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#4A76A8" flat small   @click.native="groups.modals.renameCatSelected = false">Закрыть</v-btn>
            <v-btn v-if='groups.renameList.title.length>0 ' :loading="groups.renameList.loading"  :disabled="groups.renameList.loading" color="#4A76A8" small class="white--text"  @click="renameCatList()">Изменить</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>




    <v-dialog v-model="groups.modals.removeCatSelected" scrollable max-width="350px">
        <v-card style="min-height:300px" >

          <v-toolbar flat >
          <v-icon>mdi-delete</v-icon>
          <v-toolbar-title style="color:gray">    {{groups.selectedCat}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon style="cursor: pointer" color="#4A76A8" @click.native="groups.modals.removeCatSelected = false" >mdi-close</v-icon>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-text fluid   style="height: 300px;">
          Подтвердите удаление списка <span style="color:green">{{groups.selectedCat}}</span>,
          отменить данное действие будет невозможно, сообщества данного списка будут
          перенесены в общий список.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#4A76A8" flat small   @click.native="groups.modals.removeCatSelected = false">Закрыть</v-btn>
            <v-btn :loading="groups.removeList.loading"  :disabled="groups.removeList.loading" color="red" small class="white--text"  @click="deleteCatList()">Удалить</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>















<groups_list v-for='(item, index) in beforeDisplayedQ.slice(0,groups.displayCount)' :data='item' :index='index' :groups='groups' :modals='modals'> </groups_list>



<div id="no_result" v-if="beforeDisplayedQ.length === 0 && !groups.loading" > <span >
Среди Ваших сообществ совпадений не найдено. Вы можете попробовать найти <span style="color:green">{{groups.q}}</span> в поиске
</span> </div>

<div v-if="groups.loading === true" class="text-xs-center" style="marginTop:50px" >
<v-progress-circular :size="70" :width="7" color="#4A76A8" indeterminate></v-progress-circular>
</div>


  <div id="search_list" v-if="groups.searcher.list.length > 0">
    <div class="info_block"> <span style="font-size:1.1em" >Глобальный поиск: </span><span style="font-weight:bold">{{this.groups.searcher.count}}</span>  </div>



  <div id="s_list" v-for='(item, index) in this.groups.searcher.list'>
  <search_list  :groups='groups' :data='item' :index="index">  </search_list>
  </div >

    <v-btn :loading="ui.loadingMore"   block flat  color="#4A76A8" v-on:click="searchGroups()">
      показать еще
     </v-btn>

  </div>

  </div>


  <v-flex style="margin-left:20px; margin-right:15px;max-width:450px" >

  <div  v-sticky sticky-offset="stickyOffset"    style=" border:solid #E3E4E8 1px; padding-left:5px;border-radius:3px">


    <div   style="min-width:250px; max-width:450px"  >
    <div    style="margin-top: 0px;">


      <groups_meneger :groups='groups' > </groups_meneger>


    </div>
    </div>






  </div>






  </v-flex>




  </v-layout >
  </v-card-text>
  </v-card>





  </v-layout >
  </v-container>




  </div>
</template>




<script>
import axios from 'axios'
import checker from './checker.vue'
import search_list from './search_list.vue'
import groups_list from './groups_list.vue'
import add_groups from './add_groups.vue'
import delete_groups from './delete_groups.vue'
import delete_selected from './deleteSelected.vue'
import history from './history.vue'
import gr_params from './gr_params.vue'
import update_params from './update_params.vue'
import watch_new_followers from './watch_new_followers.vue'
import groups_meneger from './groups_meneger.vue'
export default {
 components: {groups_list,add_groups,gr_params,update_params,watch_new_followers,search_list,delete_groups,checker,history,delete_selected,groups_meneger},
 props:['groups','beforeDisplayedQ' ],
 data: function(){
  return {

    stickyOffset: {
      top:55
    },
    ui: {
      loadingMore:false
    },

    modals :{
      addGroups:false,
      deleteGroup: false,
      deleteSelected: false,
      checkGroup: false,
      history: false
    }
  }
},
computed: {
  qSearch: function(){
    alert(this.q)
  return  true
  }
},
methods:{


startAutoUpdater(mode){
this.groups.update_params.is = !this.groups.update_params.is
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/updater_starter.php', {
method: 'POST',
data : {mode:mode},
}).then(response => {


})
},

deleteCatList(){
  this.groups.removeList.loading = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/change_list.php',{
    method: 'POST',
    data: {
      type: 'delete',
      listName: this.groups.selectedCat,
    }
  })
  .then( response => {
    this.groups.catList.splice(this.groups.catList.indexOf(this.groups.selectedCat),1)
    this.groups.selectedCat = 'Общий список'

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
       method: 'POST',
       data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
       }).then(response => {
   //this.groups.loading = false
   if(response.data.one.groups){
   this.groups.all = response.data.one.groups
   this.groups.catList = response.data.one.catList
   this.groups.selectedCat = response.data.one.selectedCat
  } else this.groups.all = []
   this.active
   this.groups.beforeDisplayed = this.groups.active

   this.groups.removeList.loading = false
   this.groups.modals.removeCatSelected = false

       })
  })
},



renameCatList(){
  this.groups.renameList.loading  = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/change_list.php',{
    method: 'POST',
    data: {
      type: 'rename',
      listName: this.groups.selectedCat,
      newName:  this.groups.renameList.title ,
    }
  })
  .then( response => {

    this.groups.catList[this.groups.catList.indexOf(this.groups.selectedCat)] = this.groups.renameList.title
    this.groups.selectedCat = this.groups.renameList.title

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
       method: 'POST',
       data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
       }).then(response => {
   this.groups.loading = false
   if(response.data.one.groups){
   this.groups.all = response.data.one.groups
   this.groups.catList = response.data.one.catList
   this.groups.selectedCat = response.data.one.selectedCat
  } else this.groups.all = []
   this.active
   this.groups.beforeDisplayed = this.groups.active

   this.groups.renameList.loading = false
   this.groups.modals.renameCatSelected = false

       })
  })
},




catData(){
this.groups.all = []
this.groups.loading = true
this.groups.displayCount = 25
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
       method: 'POST',
       data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
       }).then(response => {
   this.groups.loading = false
   if(response.data.one.groups){
   this.groups.all = response.data.one.groups
   this.groups.catList = response.data.one.catList
   this.groups.selectedCat = response.data.one.selectedCat
  } else this.groups.all = []
   this.active
   this.groups.beforeDisplayed = this.groups.active
       })
  },




  offSetChange: function(){
    this.$emit('offSetChange')
  },

  searchGroups: function(){
this.ui.loadingMore =  true
this.groups.loading = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_search.php', {
         method: 'POST', data: {q:this.groups.q, offset:this.groups.searcher.offset}
       }).then(response => {
         this.ui.loadingMore =  false
         this.groups.loading = false
   this.groups.searcher.count = response.data.count
   this.groups.searcher.offset =  this.groups.searcher.offset + 20
   this.groups.searcher.list =this.groups.searcher.list.concat(response.data.items.slice(1,25))
   //console.log(this.groups.searcher.list)
   //console.log(this.groups.searcher.count)
console.log(this.groups.searcher.list)
       })
  }
},
mounted: function(){

let apper = 0

   window.addEventListener('scroll',  ()=>{
     this.ui.marginTop = window.scrollY+"px"
        if(window.scrollY>100) {
          this.ui.marginTop = window.scrollY - apper +"px"
      if(apper<60){++apper;++apper; ++apper}
        }

      if(window.scrollY<10){apper = 0}
   })
}
}


</script>

<style>
#wrapper{
  margin-top: 10px;
   margin-left: 25px ;
  border-radius: 2px;
  background-color: white;
  min-height:700px;
  width: 550px;
  border: solid 1px #E3E4E8
}
#search_list{
  margin-top: 30px;
}
.top_panel{
  background-color: #FAFBFC;
  width:100%;
  height: 40px;
  border-bottom: solid 1px #E3E4E8
}
#add_group{

  display: inline-block;
  float: right;

  margin: 7px  ;
}
.info_block{
  padding: 10px;


  display: inline-block;
  align-content: center;
}
#group_search_input_wrap{
  width:100%;
  margin-top: 15px;

}
#input_wrap{
  height: 35px;
  margin-left: 20px;
  width: 510px;
  border: solid 1px #E3E4E8;
  border-radius: 2px;
}
#search_btn {
  background-size: 45px 35px;
  display: inline-block;
  border-left: solid 1px #E3E4E8;
  height: 100%;
  width: 45px;
  float:right;
  background-color: #F0F2F5;
}
#search_btn:hover{
  background-color: #E9EBF0;
  cursor: pointer;
}


#input_wrapper{
  margin-left: 10px  ;
  height:100%;
  display: inline-block;
}
#input_groups {
  border: none;
  width:400px;
  margin-top: 8px;
}
#input_groups:focus {
  outline: none;
}


#groups_list {
  margin-top: 15px;

}
#no_result {
  margin-left: 10%;
  margin-top: 15px;
  width:80%;
  color:#9D9D9D;
  min-height: 45px;
  overflow:hidden
}
.selector:hover{
  border-bottom: solid #CAD2DB 2px
}
</style>
